import React, { useState, useEffect, useRef } from 'react'
import { Card, Row, Col } from 'antd'
import moment from 'moment'
import dayjs from 'dayjs'
import {
  clcRfidNddcBindHistoryReport,
  clcRfidNddcBindHistorySummary,
  exportClcRfidNddcBindHistoryReport,
  clcReportPlantList
} from '@/services/rfid/nddc/clcRfidBindReport'
import { getRFDeviceList } from '@/services/configuration/config'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import {
  numFormat,
  paginationInit,
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  dateFormatYearMonthDay,
  isChineseFun,
  initValueAndLabel
} from '@/utils/common'
const startMonth = dayjs().subtract(1, 'months')
const endMonth = dayjs()
export const PLANT_LIST = [
  { value: '1025', label: '1025' },
  { value: '1027', label: '1027' }
]
const ClcRfidBindHistoryReport = () => {
  const BIND_STATUS = [
    { value: 0, label: () => formatMessageNew(`languageObj.qrCode.bound0`) },
    { value: 1, label: () => formatMessageNew(`languageObj.qrCode.bound1`) },
    { value: 2, label: () => formatMessageNew(`languageObj.qrCode.bound2`) }
  ]
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  const [tableListTotal, setTableListTotal] = useState([])
  let searchListInit = [
    {
      type: 'timeRange',
      label: 'languageObj.clcRfidBindReport.date',
      key: 'timeRange',
      format: dateFormatYearMonthDay,
      isdefaultfilter: 'true',
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.clcRfidBindReport.status',
      key: 'status',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: BIND_STATUS,
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.waverunNo',
      key: 'waverunNo',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.commonLocale.plant',
      key: 'plantCode',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.clcRfidBindReport.platformOrderNo',
      key: 'platformOrderNumber',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.clcRfidBindReport.giOrderNo',
      key: 'giOrderNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.cartonNo',
      key: 'cartonNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.productName',
      key: 'productName',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.productCode',
      key: 'productCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.clcRfidBindReport.rfidEpc',
      key: 'rfidEpc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.qrCode',
      key: 'qrCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.upc',
      key: 'upc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.clcRfidBindReport.carrierTrackingNo',
      key: 'carrierTrackingNo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.clcRfidBindReport.device',
      key: 'operator',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const tableColumnsTotal = [
    {
      title: formatMessageNew('languageObj.commonLocale.plant'),
      dataIndex: 'plantCode',
      width: 80
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.carton'),
      dataIndex: 'carton',
      children: [
        {
          title: formatMessageNew('languageObj.clcRfidBindReport.totalCartonQty'),
          dataIndex: 'totalCartonQty',
          width: 100,
          render: text => {
            return numFormat(text)
          }
        },
        {
          title: formatMessageNew('languageObj.clcRfidBindReport.bindCartonQty'),
          dataIndex: 'bindCartonQty',
          width: 100,
          render: text => {
            return numFormat(text)
          }
        },
        {
          title: formatMessageNew('languageObj.clcRfidBindReport.unbindCartonQty'),
          dataIndex: 'unbindCartonQty',
          width: 120,
          render: text => {
            return numFormat(text)
          }
        }
      ]
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.sku'),
      dataIndex: 'sku',
      children: [
        {
          title: formatMessageNew('languageObj.clcRfidBindReport.totalSkuQty'),
          dataIndex: 'totalSkuQty',
          width: 100,
          render: text => {
            return numFormat(text)
          }
        },
        {
          title: formatMessageNew('languageObj.clcRfidBindReport.bindSkuQty'),
          dataIndex: 'bindSkuQty',
          width: 100,
          render: text => {
            return numFormat(text)
          }
        },
        {
          title: formatMessageNew('languageObj.clcRfidBindReport.unbindSkuQty'),
          dataIndex: 'unbindSkuQty',
          width: 100,
          render: text => {
            return numFormat(text)
          }
        }
      ]
    }
  ]
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.qrCode.itemSstatus'),
      dataIndex: 'status',
      width: 100,
      render: text => {
        return <div className="word_break_all">{formatMessageNew(`languageObj.qrCode.bound${text}`)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.plant'),
      dataIndex: 'plantCode',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.waverunNo'),
      dataIndex: 'waverunNo',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.cartonNo'),
      dataIndex: 'cartonNumber',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.qrCode.productCode'),
      dataIndex: 'productCode',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.upc'),
      dataIndex: 'upc',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.rfidEpc'),
      dataIndex: 'rfidEpc',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.qrCode'),
      dataIndex: 'qrCode',
      width: 100,
      render: (text, record) => {
        return <div className="word_break_all">{record.globalQrCode || record.localQrCode}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.productName'),
      dataIndex: 'productName',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.platformOrderNo'),
      dataIndex: 'platformOrderNumber',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.giOrderNo'),
      dataIndex: 'giOrderNumber',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.carrierTrackingNo'),
      dataIndex: 'carrierTrackingNo',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.device'),
      dataIndex: 'operator',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.date'),
      dataIndex: 'createTime',
      width: 120,
      render: text => {
        return text
      }
    }
  ]
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  useEffect(() => {
    getDeviceList()
    getPlantOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getPlantOptions = () => {
    clcReportPlantList().then(res => {
      const dt = res.resultData || []
      const options = initValueAndLabel(dt)
      searchList.forEach(item => {
        if (item.key === 'plantCode') item.selectList = options
      })
      setSearchList([...searchList])
    })
  }
  const getDeviceList = () => {
    const params = {
      pageNo: 1,
      size: 999
    }
    getRFDeviceList(params).then(res => {
      const dt = res.resultData.records
      const options = dt.map(item => ({ label: item.deviceCode, value: item.deviceCode }))
      searchList.forEach(item => {
        if (item.key === 'operator') item.selectList = options
      })
      setSearchList([...searchList])
    })
  }
  const searchClearDataBtn = () => {
    // formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1,
      total: 0
    }
    setPagination(pg)
    setTableList([])
    setTableListTotal([])
    formRef && formRef.current.setValue({ timeRange: [] })
    // setQueryFlag(!queryFlag)
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      ...info,
      startCreateDate: formatStartTime(info.timeRange),
      endCreateDate: formatEndTime(info.timeRange)
    }
    delete params.timeRange
    return params
  }

  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    clcRfidNddcBindHistorySummary(params).then(res => {
      let dt = res.resultData
      setTableListTotal(dt)
    })
    clcRfidNddcBindHistoryReport(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const downLoadFun = () => {
    const params = {
      ...getParams(),
      ...isChineseFun()
    }
    exportClcRfidNddcBindHistoryReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  return (
    <Card bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar
          ref={formRef}
          searchList={searchList}
          showCollapseBtn={true}
          showSearchBtn={true}
          showClearBtn={true}
          onSearch={searchDataBtn}
          onClear={searchClearDataBtn}
        />
      </div>

      <div className="content-container">
        <Row type="flex" justify="center">
          <Col span={18}>
            <AntdTable bordered columns={tableColumnsTotal} dataSource={tableListTotal} />
          </Col>
        </Row>
        <div className="mt30 pt10">
          <AntdTable
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            columnsKey="columns_clcRfidBindHistoryReport"
            pagination={pagination}
            onDownload={downLoadFun}
            onChange={handleTableChange}
          />
        </div>
      </div>
    </Card>
  )
}
export default ClcRfidBindHistoryReport
